<script>
export default {
    name: "IconPaymentMir"
}
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="48px" height="25px" viewBox="270 0 280 120">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M295.933 26.0118C298.149 25.9993 304.734 25.4023 307.523 34.8652C309.402 41.2383 312.395 51.6797 316.501 66.187H318.174C322.578 50.8919 325.604 40.4518 327.25 34.8652C330.069 25.3038 337.115 26.0118 339.932 26.0118H361.676V94H339.514V53.9332H338.029L325.674 94H309.001L296.647 53.9046H295.161V94H273V26.0118H295.933ZM393.498 26.0118V66.1085H395.266L410.294 33.1377C413.21 26.5764 419.428 26.0118 419.428 26.0118H440.874V94H418.25V53.9046H416.482L401.749 86.8741C398.831 93.4067 392.32 94 392.32 94H370.874V26.0118H393.498ZM519.071 58.3207C515.915 67.31 506.005 73.7479 495.034 73.7479H471.307V94H449.793V58.3207H519.071Z" fill="#0F754E"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M496.069 26.0123H448.663C449.791 41.1478 462.76 54.1058 476.184 54.1058H520.565C523.126 41.5255 514.309 26.0123 496.069 26.0123Z" fill="url(#paint0_linear_3519_20220)"/>
        <defs>
            <linearGradient id="paint0_linear_3519_20220" x1="521" y1="43.6843" x2="448.663" y2="43.6843" gradientUnits="userSpaceOnUse">
                <stop stop-color="#1F5CD7"/>
                <stop offset="1" stop-color="#02AEFF"/>
            </linearGradient>
        </defs>
    </svg>
</template>

<style scoped lang="scss">

</style>
